/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { ThemeProvider } from "styled-components";
import {
	VideoTileGrid,
	lightTheme,
	GlobalStyles,
	UserActivityProvider,
} from "amazon-chime-sdk-component-library-react";
import MeetingControls from "./MeetingControls";
import { TilePlaceholder } from "./TilePlaceholder";

const Meeting = ({ classes }) => {
	const renderMeetingScreen = (
		<main className={classes.paceMeetingLayout}>
			<div className={classes.paceMeetingTileContent}>
				<VideoTileGrid noRemoteVideoView={<TilePlaceholder classes={classes} />} />
			</div>
			<div className={classes.meetingControls}>
				<UserActivityProvider>
					<MeetingControls classes={classes} />
				</UserActivityProvider>
			</div>
		</main>
	);

	return <Theme>{renderMeetingScreen}</Theme>;
};

const Theme = ({ children }) => {
	return (
		<ThemeProvider theme={lightTheme}>
			<GlobalStyles />
			{children}
		</ThemeProvider>
	);
};
export default Meeting;
